class QuestionsHelper {
  getSingleAnswerText (question) {
    if (
      question == undefined ||
      question.resource_answers == undefined ||
      question.resource_answers.length == 0
    ) {
      return ''
    }
    return this.getDisplayTextForSingleOption(
      question.resource_answers[0].option_id,
      question
    )
  }

  getAllAnswersText (question) {
    let answers_texts = []
    for (let i = 0; i < question.resource_answers.length; i++) {
      let resource_answer = question.resource_answers[i]
      answers_texts.push(this.getDisplayTextForSingleOption(resource_answer.option_id, question))
    }
    return answers_texts.join(', ')
  }

  getDisplayTextForSingleOption (option_id, question) {
    if (question.options === null) {
      return ''
    }
    for (let option of question.options) {
      if (option_id == option.id) {
        return option.text
      }
    }
  }

  getQuestionsWithAnswers (questions) {
    let returned_questions = []
    for (let i = 0; i < questions.length; i++) {
      let question = questions[i]
      let option_ids = this.getAnsweredOptionIdsFromQuestion(question)
      let answer = this.getDisplayTextForOptionIds(option_ids, question)
      question.answers = answer
      returned_questions.push(question)
    }
    return returned_questions
  }

  hasRangeValue (question) {
    return (
      question.resource_answers.length > 0 &&
      question.resource_answers[0].range_value != undefined
    )
  }

  getDisplayTextForOptionIds (option_ids, question) {
    if (this.hasRangeValue(question)) {
      return question.resource_answers[0].range_value
    }
    var display_answers = ''
    for (let option_id of option_ids) {
      display_answers +=
        this.getDisplayTextForSingleOption(option_id, question) + ', '
    }
    return display_answers
  }

  getAnsweredOptionIdsFromQuestion (question) {
    var option_ids = []
    for (let answer of question.resource_answers) {
      option_ids.push(answer.option_id)
    }
    return option_ids
  }

  getAllDesignators () {
    return 'external_rank,work_scope,office_size,urgency,seniority,benefits,approve_terms,approve_email,preferred_work_region,near_train,near_me,certification_date,psychometric,psychometric_discrete,salary,salary_discrete,work_entails,personal_traits,clients_volume,interview_score,proactive_promotion,accept_push,is_discrete,sounds,arrived_through,independent_case_management,questioned_witness,drafted_english_papers,affirmative_action,internship_date,job_title,certification_date_cpa,worked_as_corporate_counsel,elite,sign_in_platform,vetted_by,only_peek,display_extra_info_swipe,is_senior,gender,is_auto_send,files_approved,stargate_first_entry,stargate_supplier,skip_educations_filter,skip_seniority_filter,graduation_position,parent_env,is_send_one_file'
  }

  getQuestionByDesignator (questions, designator) {
    for (let i = 0; i < questions.length; i++) {
      let question = questions[i]
      if (question.designator == designator) {
        return question
      }
    }
  }
}

export default QuestionsHelper
